export default __webpack_public_path__ + "static/media/chil.172f12d8.png";